export const AMENITIES_ROOM = {
  1: {
    id: 1,
    originalName: 'Air Conditioning',
    translateToken: 'air-conditioning',
  },
  2: {
    id: 2,
    originalName: 'Deck or Patio',
    translateToken: 'deck-or-patio',
  },
  4: {
    id: 4,
    originalName: 'Wood Floors',
    translateToken: 'wood-floors',
  },
  8: {
    id: 8,
    originalName: 'Yard',
    translateToken: 'yard',
  },
  16: {
    id: 16,
    originalName: 'Carpet',
    translateToken: 'carpet',
  },
  32: {
    id: 32,
    originalName: 'Storage',
    translateToken: 'storage',
  },
  64: {
    id: 64,
    originalName: 'Gym',
    translateToken: 'gym',
  },
  128: {
    id: 128,
    originalName: 'Parking',
    translateToken: 'parking',
  },
  256: {
    id: 256,
    originalName: 'Elevator',
    translateToken: 'elevator',
  },
  512: {
    id: 512,
    originalName: 'Fireplace',
    translateToken: 'fireplace',
  },
  1024: {
    id: 1024,
    originalName: 'Laundry',
    translateToken: 'laundry',
  },
  2048: {
    id: 2048,
    originalName: 'Tennis',
    translateToken: 'tennis',
  },
  4096: {
    id: 4096,
    originalName: 'Jacuzzi',
    translateToken: 'jacuzzi',
  },
  8192: {
    id: 8192,
    originalName: 'Dishwasher',
    translateToken: 'dishwasher',
  },
  16_384: {
    id: 16_384,
    originalName: 'Pool',
    translateToken: 'pool',
  },
  32_768: {
    id: 32_768,
    originalName: 'Private Bathroom',
    translateToken: 'private-bathroom',
  },
  65_536: {
    id: 65_536,
    originalName: 'Phone Jack',
    translateToken: 'phone-jack',
  },
  131_072: {
    id: 131_072,
    originalName: 'Private Entrance',
    translateToken: 'private-entrance',
  },
  524_288: {
    id: 524_288,
    originalName: 'Cable TV Jack',
    translateToken: 'cable-tv-jack',
  },
  1_048_576: {
    id: 1_048_576,
    originalName: 'Private Closet',
    translateToken: 'private-closet',
  },
  2_097_152: {
    id: 2_097_152,
    originalName: 'Internet',
    translateToken: 'internet',
  },
  4_194_304: {
    id: 4_194_304,
    originalName: 'Wireless Internet',
    translateToken: 'wireless-internet',
  },
} as const;

export const AMENITIES_APARTMENT = {
  3: {
    id: 3,
    originalName: 'High-rise',
    translateToken: 'high-rise',
  },
  4: {
    id: 4,
    originalName: 'Low-rise',
    translateToken: 'low-rise',
  },
  5: {
    id: 5,
    originalName: 'Disability Access',
    translateToken: 'disability-access',
  },
  7: {
    id: 7,
    originalName: 'Doorman',
    translateToken: 'doorman',
  },
  8: {
    id: 8,
    originalName: 'Elevator',
    translateToken: 'elevator',
  },
  9: {
    id: 9,
    originalName: 'Walkup',
    translateToken: 'walkup',
  },
  10: {
    id: 10,
    originalName: 'Health Club',
    translateToken: 'health-club',
  },
  12: {
    id: 12,
    originalName: 'Laundromat',
    translateToken: 'laundromat',
  },
  13: {
    id: 13,
    originalName: 'Covered Parking',
    translateToken: 'covered-parking',
  },
  14: {
    id: 14,
    originalName: 'Garage',
    translateToken: 'garage',
  },
  15: {
    id: 15,
    originalName: 'Parking Lot',
    translateToken: 'parking-lot',
  },
  17: {
    id: 17,
    originalName: 'Street Parking',
    translateToken: 'street-parking',
  },
  18: {
    id: 18,
    originalName: 'Near Bus Stop',
    translateToken: 'near-bus-stop',
  },
  19: {
    id: 19,
    originalName: 'Near Subway',
    translateToken: 'near-subway',
  },
  21: {
    id: 21,
    originalName: 'Electronic Security',
    translateToken: 'electronic-security',
  },
  22: {
    id: 22,
    originalName: 'Security',
    translateToken: 'security',
  },
  23: {
    id: 23,
    originalName: 'Swimming Pool',
    translateToken: 'swimming-pool',
  },
  24: {
    id: 24,
    originalName: 'Internet',
    translateToken: 'internet',
  },
  25: {
    id: 25,
    originalName: 'Wireless Internet',
    translateToken: 'wireless-internet',
  },
} as const;

export const HOUSEHOLD_SEX = {
  1_258_548: {
    id: 1_258_548,
    originalName: 'Female',
    translateToken: 'female',
  },
  1_258_549: {
    id: 1_258_548,
    originalName: 'Male',
    translateToken: 'male',
  },
  1_258_550: {
    id: 1_258_550,
    originalName: 'Co-ed',
    translateToken: 'co-ed',
  },
} as const;

export const BUILDING_TYPES = {
  43: {
    id: 43,
    originalName: 'Apartment Building (1-10 units)',
    translateToken: 'apartment-building-1-10-units',
  },
  44: {
    id: 44,
    originalName: 'Apartment Building (10+ units)',
    translateToken: 'apartment-building-10-plus-units',
  },
  45: {
    id: 45,
    originalName: 'Apartment Complex',
    translateToken: 'apartment-complex',
  },
  46: {
    id: 46,
    originalName: 'House',
    translateToken: 'house',
  },
} as const;

export const CLEANLINESS_LEVELS = {
  47: {
    id: 47,
    originalName: 'Clean',
    translateToken: 'clean',
  },
  48: {
    id: 48,
    originalName: 'Average',
    translateToken: 'average',
  },
  49: {
    id: 49,
    originalName: 'Messy',
    translateToken: 'messy',
  },
} as const;

export const OVERNIGHT_GUESTS = {
  71: {
    id: 71,
    originalName: 'Never',
    translateToken: 'never',
  },
  76: {
    id: 76,
    originalName: 'Rarely',
    translateToken: 'rarely',
  },
  81: {
    id: 81,
    originalName: 'Occasionally',
    translateToken: 'occasionally',
  },
  85: {
    id: 85,
    originalName: 'Often',
    translateToken: 'often',
  },
} as const;

export const PARTY_HABITS = {
  112: {
    id: 112,
    originalName: 'Rarely',
    translateToken: 'rarely',
  },
  115: {
    id: 115,
    originalName: 'Occasionally',
    translateToken: 'occasionally',
  },
  117: {
    id: 117,
    originalName: 'Weekends',
    translateToken: 'weekends',
  },
  121: {
    id: 121,
    originalName: 'Daily',
    translateToken: 'daily',
  },
} as const;

export const GET_UP = {
  38: {
    id: 38,
    originalName: 'Before 6AM',
    translateToken: 'before-6am',
  },
  39: {
    id: 39,
    originalName: '6AM - 8AM',
    translateToken: '6am-8am',
  },
  40: {
    id: 40,
    originalName: '8AM - 10AM',
    translateToken: '8am-10am',
  },
  41: {
    id: 41,
    originalName: '10AM - 12PM',
    translateToken: '10am-12pm',
  },
  42: {
    id: 42,
    originalName: 'After 12PM',
    translateToken: 'after-12pm',
  },
} as const;

export const GO_TO_BED = {
  50: {
    id: 50,
    originalName: 'Before 8PM',
    translateToken: 'before-8pm',
  },
  51: {
    id: 51,
    originalName: '8PM - 10PM',
    translateToken: '8pm-10pm',
  },
  53: {
    id: 53,
    originalName: '10PM - 12AM',
    translateToken: '10pm-12am',
  },
  55: {
    id: 55,
    originalName: '12AM - 2AM',
    translateToken: '12am-2am',
  },
  57: {
    id: 57,
    originalName: 'After 2AM',
    translateToken: 'after-2am',
  },
} as const;

export const FOOD_PREFERENCE = {
  33: {
    id: 33,
    originalName: 'Almost Anything',
    translateToken: 'almost-anything',
  },
  34: {
    id: 34,
    originalName: 'Fish Only',
    translateToken: 'fish-only',
  },
  35: {
    id: 35,
    originalName: 'Vegetarian',
    translateToken: 'vegetarian',
  },
  36: {
    id: 36,
    originalName: 'Vegan',
    translateToken: 'vegan',
  },
  37: {
    id: 37,
    originalName: 'Kosher',
    translateToken: 'kosher',
  },
} as const;

export const SMOKING_HABITS = {
  164: {
    id: 164,
    originalName: 'No',
    translateToken: 'no',
  },
  165: {
    id: 165,
    originalName: 'Yes',
    translateToken: 'yes',
  },
  166: {
    id: 166,
    originalName: 'Outside only',
    translateToken: 'outside-only',
  },
} as const;

export const SMOKING_PREFERENCE = {
  161: {
    id: 161,
    originalName: 'No',
    translateToken: 'no',
  },
  162: {
    id: 162,
    originalName: 'Yes',
    translateToken: 'yes',
  },
  163: {
    id: 163,
    originalName: 'Outside only',
    translateToken: 'outside-only',
  },
} as const;

export const WORK_SCHEDULE = {
  167: {
    id: 167,
    originalName: 'Professional (9-5)',
    translateToken: 'professional-9-5',
  },
  169: {
    id: 169,
    originalName: 'Student',
    translateToken: 'student',
  },
  171: {
    id: 171,
    originalName: 'Work at Night',
    translateToken: 'work-at-night',
  },
  174: {
    id: 174,
    originalName: 'Work at Home',
    translateToken: 'work-at-home',
  },
  175: {
    id: 175,
    originalName: 'Mixed',
    translateToken: 'mixed',
  },
} as const;

export const OCCUPATION = {
  96: {
    id: 96,
    originalName: 'Accounting',
    translateToken: 'accounting',
  },
  97: {
    id: 97,
    originalName: 'Administration/ Secretarial',
    translateToken: 'administration-secretarial',
  },
  98: {
    id: 98,
    originalName: 'Advertising',
    translateToken: 'advertising',
  },
  99: {
    id: 99,
    originalName: 'Architecture/ Design',
    translateToken: 'architecture-design',
  },
  100: {
    id: 100,
    originalName: 'Automotive/ Mechanical',
    translateToken: 'automotive-mechanical',
  },
  101: {
    id: 101,
    originalName: 'Aviation/ Aeronautical',
    translateToken: 'aviation-aeronautical',
  },
  102: {
    id: 102,
    originalName: 'Beauty/ Fashion',
    translateToken: 'beauty-fashion',
  },
  103: {
    id: 103,
    originalName: 'Biology/ Life Science',
    translateToken: 'biology-life-science',
  },
  104: {
    id: 104,
    originalName: 'Broadcasting/ Publishing',
    translateToken: 'broadcasting-publishing',
  },
  106: {
    id: 106,
    originalName: 'Consulting',
    translateToken: 'consulting',
  },
  107: {
    id: 107,
    originalName: 'Customer Service/ Support',
    translateToken: 'customer-service-support',
  },
  109: {
    id: 109,
    originalName: 'Creative/ Media',
    translateToken: 'creative-media',
  },
  110: {
    id: 110,
    originalName: 'Education/ Training',
    translateToken: 'education-training',
  },
  113: {
    id: 113,
    originalName: 'Engineering',
    translateToken: 'engineering',
  },
  116: {
    id: 116,
    originalName: 'Finance/ Banking',
    translateToken: 'finance-banking',
  },
  119: {
    id: 119,
    originalName: 'Government/ Social Service',
    translateToken: 'government-social-service',
  },
  123: {
    id: 123,
    originalName: 'Health Services',
    translateToken: 'health-services',
  },
  124: {
    id: 124,
    originalName: 'Hospitality',
    translateToken: 'hospitality',
  },
  125: {
    id: 125,
    originalName: 'Human Resources/ Recruiting',
    translateToken: 'human-resources-recruiting',
  },
  126: {
    id: 126,
    originalName: 'IT/Computers',
    translateToken: 'it-computers',
  },
  127: {
    id: 127,
    originalName: 'Insurance',
    translateToken: 'insurance',
  },
  128: {
    id: 128,
    originalName: 'Internet/Media',
    translateToken: 'internet-media',
  },
  129: {
    id: 129,
    originalName: 'Law Enforcement/ Security',
    translateToken: 'law-enforcement-security',
  },
  130: {
    id: 130,
    originalName: 'Legal',
    translateToken: 'legal',
  },
  131: {
    id: 131,
    originalName: 'Manufacturing/ Production',
    translateToken: 'manufacturing-production',
  },
  132: {
    id: 132,
    originalName: 'Marketing/ Public Relations',
    translateToken: 'marketing-public-relations',
  },
  133: {
    id: 133,
    originalName: 'Military',
    translateToken: 'military',
  },
  134: {
    id: 134,
    originalName: 'Non-Profit',
    translateToken: 'non-profit',
  },
  135: {
    id: 135,
    originalName: 'Other',
    translateToken: 'other',
  },
  138: {
    id: 138,
    originalName: 'Physical Science/ Environment',
    translateToken: 'physical-science-environment',
  },
  141: {
    id: 141,
    originalName: 'Real Estate',
    translateToken: 'real-estate',
  },
  144: {
    id: 144,
    originalName: 'Retail',
    translateToken: 'retail',
  },
  147: {
    id: 147,
    originalName: 'Sales',
    translateToken: 'sales',
  },
  149: {
    id: 149,
    originalName: 'Sports/ Fitness',
    translateToken: 'sports-fitness',
  },
  151: {
    id: 151,
    originalName: 'Student/ Graduate',
    translateToken: 'student-graduate',
  },
  154: {
    id: 154,
    originalName: 'Student/ Undergraduate',
    translateToken: 'student-undergraduate',
  },
  155: {
    id: 155,
    originalName: 'Telecommunications',
    translateToken: 'telecommunications',
  },
  156: {
    id: 156,
    originalName: 'Trades/ Labor',
    translateToken: 'trades-labor',
  },
  157: {
    id: 157,
    originalName: 'Transportation/ Logistic',
    translateToken: 'transportation-logistic',
  },
} as const;

export const PETS = {
  1: {
    id: 1,
    originalName: 'Cats',
    translateToken: 'cats',
  },
  2: {
    id: 2,
    originalName: 'Dogs',
    translateToken: 'dogs',
  },
  8: {
    id: 8,
    originalName: 'Small Pets',
    translateToken: 'small-pets',
  },
  16: {
    id: 16,
    originalName: 'Small Pets',
    translateToken: 'small-pets',
  },
  32: {
    id: 32,
    originalName: 'Birds',
    translateToken: 'birds',
  },
  64: {
    id: 64,
    originalName: 'Fish',
    translateToken: 'fish',
  },
  128: {
    id: 128,
    originalName: 'Reptiles',
    translateToken: 'reptiles',
  },
} as const;

export const BEDROOMS = {
  1: {
    id: 1,
    originalName: 'Studio',
    translateToken: 'studio',
  },
  2: {
    id: 2,
    originalName: '1 bedroom',
    translateToken: '1-bedroom',
  },
  6: {
    id: 6,
    originalName: '2 bedrooms',
    translateToken: '2-bedrooms',
  },
  11: {
    id: 11,
    originalName: '3 bedrooms',
    translateToken: '3-bedrooms',
  },
  16: {
    id: 16,
    originalName: '4 bedrooms',
    translateToken: '4-bedrooms',
  },
  20: {
    id: 20,
    originalName: '5 bedrooms',
    translateToken: '5-bedrooms',
  },
} as const;

export const BATHROOMS = {
  27: {
    id: 27,
    originalName: '1',
    translateToken: '1',
  },
  28: {
    id: 28,
    originalName: '1.5',
    translateToken: '1-5',
  },
  29: {
    id: 29,
    originalName: '2',
    translateToken: '2',
  },
  30: {
    id: 30,
    originalName: '2.5',
    translateToken: '2-5',
  },
  31: {
    id: 31,
    originalName: '3',
    translateToken: '3',
  },
  32: {
    id: 32,
    originalName: '3.5 +',
    translateToken: '3-5-plus',
  },
} as const;

export const APT_SIZE_UNITS = {
  0: {
    id: 0,
    originalName: 'Square meters',
    translateToken: 'square-meters',
  },
  1: {
    id: 1,
    originalName: 'Square feet',
    translateToken: 'square-feet',
  },
} as const;
